<template>
  <div style="line-height: 20px; font-size: 20px" id="zernikeSettings">
    <el-row style="margin-top: 20px">
      <el-col :offset="1" :span="11">
        <IconButton
          style="margin-top: 5px"
          :selected="zernikeSet.lhaa === 'LOA'"
          @click.native="changeHLAA('LOA')"
          >LOA</IconButton
        >
      </el-col>
      <el-col :offset="1" :span="11">
        <IconButton
          style="margin-top: 5px"
          :selected="zernikeSet.lhaa === 'HOA'"
          @click.native="changeHLAA('HOA')"
          >HOA</IconButton
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :offset="1" :span="11">
        <IconButton
          style="margin-top: 5px"
          :selected="zernikeSet.lhaa === 'ALL-ON'"
          @click.native="changeHLAA('ALL-ON')"
          >ALL ON</IconButton
        >
      </el-col>
      <el-col :offset="1" :span="11">
        <IconButton
          style="margin-top: 5px"
          :selected="zernikeSet.lhaa === 'ALL-OFF'"
          @click.native="changeHLAA('ALL-OFF')"
          >ALL OFF</IconButton
        >
      </el-col>
    </el-row>
    <br />
    <el-row>
      <div style="border: 1px solid gray; margin-left: 10px; padding-top: 10px">
        <div style="padding-top: 10px">
          {{ $t("langcfg.txtZernikeAnalysis") }}
        </div>
        <!-- <div style="padding-top: 10px">
          {{ $t('langcfg.txtClickForOption') }}
        </div> -->
        <br />
        <div class="input-block">
          <span class="input-label">{{ $t("langcfg.txtOrder") }}:</span>
          <el-input-number
            v-model="order"
            @change="orderDiaChanged"
            data-name="order"
            @focus="handleClick('order')"
            :min="2"
            :max="8"
            :precision="0"
            :step="1"
            :label="'Order'"
          ></el-input-number>
        </div>
        <div class="input-block">
          <span class="input-label">{{ $t("langcfg.txtDia") }}:</span>
          <el-input-number
            @change="orderDiaChanged"
            v-model="diameter"
            data-name="diameter"
            @focus="handleClick('diameter')"
            :min="2"
            :max="12"
            :precision="0"
            :step="1"
            :label="'Order'"
          ></el-input-number>
          <span>mm</span>
        </div>
        <br />
        <br />
        <el-row>
          <el-col :offset="1" style="text-align: left">{{ $t("langcfg.txtMaxValue") }}:</el-col>
        </el-row>
        <br />
        <el-row>
          <el-col style="text-align: left" :offset="1" :span="8">{{ maxPeakTitle.xLabel }}:</el-col>
          <el-col :offset="1" :span="14">{{ maxPeakXY.x | paramNormal }}</el-col>
        </el-row>
        <br />
        <el-row>
          <el-col style="text-align: left" :offset="1" :span="8">{{ maxPeakTitle.yLabel }}:</el-col>
          <el-col :offset="1" :span="14">{{ maxPeakXY.y | paramNormal }}</el-col>
        </el-row>
        <br />
        <br />
        <el-row>
          <el-col :offset="1" style="text-align: left">{{ $t("langcfg.txtEffParams") }}:</el-col>
        </el-row>
        <br />
        <el-row>
          <el-col style="text-align: left" :offset="1" :span="8"
            >{{ $t("langcfg.txtMean") }}:</el-col
          >
          <el-col :offset="1" :span="14">{{ zernikeViewParams.meanRms.mean | paramNormal }}</el-col>
        </el-row>
        <br />
        <el-row>
          <el-col style="text-align: left" :offset="1" :span="8">RMS:</el-col>
          <el-col :offset="1" :span="14">{{ zernikeViewParams.meanRms.rms | paramNormal }}</el-col>
        </el-row>
        <br />
      </div>
    </el-row>
    <!-- <ZernikeSetting :isVisible.sync="isSettingVisibleBoolen" /> -->
  </div>
</template>
<script>
import ZernikeConfig from "../config/zernike";
import IconButton from "./IconButton.vue";
import ZernikeSetting from "../pages/dialog-forms/ZernikeSetting";
import { mapGetters, mapActions } from "vuex";
import EVENTS from "../../bus";
import { cartesian2polar } from "../shared";
import { canConvertNumber } from "../../shared/utils";
let timeout, timeoutwait, timeoutLoading;
export default {
  name: "ZernikeSettingsView",
  data() {
    return {
      isSettingVisibleBoolen: false,
      isDE: false,
      order: 2,
      diameter: 8
    };
  },
  computed: {
    ...mapGetters(["zernikeSet", "zernikeViewParams", "zernikeParams", "dataShowSettings"]),
    maxPeakTitle: function () {
      return this.dataShowSettings.isCartesian
        ? { xLabel: "X-Pos", yLabel: "Y-Pos" }
        : { xLabel: "R", yLabel: "θ" };
    },
    maxPeakXY: function () {
      if (!this.zernikeViewParams.maxPeak) {
        return {
          x: -1000,
          y: -1000
        };
      }
      if (this.dataShowSettings.isCartesian) {
        return this.zernikeViewParams.maxPeak;
      } else {
        const { x, y } = this.zernikeViewParams.maxPeak;
        let { dist, angle } = cartesian2polar(x, y);
        return {
          x: dist,
          y: angle
        };
      }
    }
  },
  mounted() {
    this.isDE = window.settings.language === "de";
    this.diameter = this.zernikeSet.diameter;
    this.order = this.zernikeSet.order;
  },
  updated() {
    this.isDE = window.settings.language === "de";
  },
  methods: {
    // 在地形图中获取
    ...mapActions({
      zernikeSetChanged: "topography/zernikeSetChanged",
      zernikeParamsChanged: "topography/zernikeParamsChanged"
    }),
    showZKSettings() {
      this.isSettingVisibleBoolen = true;
    },
    changeHLAA(mode) {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      clearTimeout(timeoutwait);
      timeoutwait = setTimeout(() => {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 5000);
      timeout = setTimeout(() => {
        this.zernikeSet.lhaa = mode;
        this.zernikeSetChanged(this.zernikeSet);
        let zernikeConfig = new ZernikeConfig(this.zernikeSet);
        for (let i = 0; i < this.zernikeParams.params.length; i++) {
          let selected = zernikeConfig.isEnabled(i) && zernikeConfig.isSelected(mode, i);
          this.zernikeParams.params[i].selected = selected;
          this.zernikeParams.params[i].enabled = zernikeConfig.isEnabled(i);
        }
        this.zernikeParamsChanged(this.zernikeParams);
      }, 500);
    },
    orderDiaChanged() {
      this.showLoading();

      setTimeout(() => {
        this.zernikeSet.diameter = this.diameter;
        this.zernikeSet.order = this.order;
        this.zernikeSetChanged(this.zernikeSet);
      }, 100);
    },
    showLoading() {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      clearTimeout(timeoutLoading);
      timeoutLoading = setTimeout(() => {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 5000);
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self[key].toString(), (value) => {
        if (canConvertNumber(value)) {
          self[key] = parseFloat(value);
          self.orderDiaChanged();
        }
      });
    }
  },
  watch: {
    "zernikeSet.order": function () {
      let zernikeConfig = new ZernikeConfig(this.zernikeSet);
      for (let i = 0; i < this.zernikeParams.params.length; i++) {
        let enabled =
          zernikeConfig.isEnabled(i) && zernikeConfig.isSelected(this.zernikeSet.lhaa, i);
        this.zernikeParams.params[i].selected = enabled;
        this.zernikeParams.params[i].enabled = zernikeConfig.isEnabled(i);
      }
      this.zernikeParamsChanged(this.zernikeParams);
    }
  },
  components: {
    IconButton,
    ZernikeSetting
  }
};
</script>
<style lang="less">
#zernikeSettings {
  .input-label {
    display: inline-block;
    width: 140px;
    font-size: 20px;
    text-align: left;
  }
  .input-block {
    text-align: left;
    padding-left: 6px;
  }
  .el-input-number {
    width: 130px;
  }
  .el-input-number /deep/ .el-input__inner {
    font-size: 20px;
  }
  .el-input-number /deep/ .el-input-number__increase {
    font-size: 20px;
  }
  .el-input-number /deep/ .el-input-number__decrease {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ZernikeSettingsView.vue